import { useQuery } from "react-query"
import { AxiosResponse } from "axios"

import { IGetLaundryCommissionRes } from "types/laundry"

import laundriesService from "api/laundriesService"

const useGetLaundryCommission = (laundryId: number | null, enabled: boolean) => {
  return useQuery("laundry_commission", async () => {
    try {
      const res: AxiosResponse<IGetLaundryCommissionRes> = await laundriesService.getLaundryCommission(laundryId)

      return res.data
    } catch(err: any) {
      return err.response
    }
  }, { enabled, refetchOnWindowFocus: false })
}

export default useGetLaundryCommission